import useArchive from "@hooks/useArchive";

export default function useSalonGalleryArchive(photos: Interfaces.Photo[] | undefined) {
    const archive = useArchive(photos)

    archive.useOptions({ box: false })
    archive.usePagination(20, "photos")
    archive.useGrid({
        columns: "2",
        gap: "m"
    })

    return archive
}